/**
 * English: Shared view helpers for agent management (status badge variant, deep links).
 * Thai: ตัวช่วยมุมมองร่วมสำหรับ agent management
 */
import { agentManagementQuery } from '../../hooks/useAgentManagementScope';
import type { AgentRow } from './useAgentRows';

export { agentManagementQuery };

export function agentDetailPath(agentId: string, org?: string, station?: string): string {
  return `/agent-management/${encodeURIComponent(agentId)}${agentManagementQuery(org, station)}`;
}

export function managerDetailPath(org?: string, station?: string): string {
  return `/agent-management/manager${agentManagementQuery(org, station)}`;
}

export function deviceStatusVariant(
  status: string | undefined,
): 'success' | 'error' | 'warning' | 'info' | 'muted' {
  const s = (status || '').toLowerCase();
  if (s.includes('online') || s.includes('active') || s === 'ok' || s === 'running') {
    return 'success';
  }
  if (s.includes('offline') || s.includes('error') || s.includes('fail') || s.includes('stopped')) {
    return 'error';
  }
  if (s.includes('warn') || s.includes('maintenance') || s.includes('idle')) {
    return 'warning';
  }
  if (!s) return 'muted';
  return 'info';
}

export function chatLinkFor(row: AgentRow): string {
  return `/chat-test?target=${encodeURIComponent(row.agent.id)}`;
}

export function controlLinkFor(row: AgentRow): string {
  return `/chat-test?target=${encodeURIComponent(row.agent.id)}`;
}

export function detailLinkFor(row: AgentRow, org?: string, station?: string): string {
  return agentDetailPath(row.agent.id, org, station);
}

export function displayDeviceType(row: AgentRow): string {
  return row.device?.device_type || (row.agent.role as string) || '—';
}
